import { Box, Dialog, Typography } from '@mui/material';
import BrandButtonView from '../../common/BrandButton';
import { formatPortalCopy } from '../../common/formatCopy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Two success dialog variants: request to join an existing entity / application to register a new sub-broker */
export var AccessSuccessKindEnum;

(function (AccessSuccessKindEnum) {
  AccessSuccessKindEnum["Member"] = "member";
  AccessSuccessKindEnum["SubBroker"] = "subBroker";
})(AccessSuccessKindEnum || (AccessSuccessKindEnum = {}));

/** Request-submitted success dialog (design success_1 / success_2): green check + heading + under-review badge + back-to-portal button */
var AccessSuccessDialog = function AccessSuccessDialog(props) {
  var open = props.open,
      kind = props.kind,
      copy = props.copy,
      entity = props.entity,
      onClose = props.onClose;
  var heading = kind === AccessSuccessKindEnum.SubBroker ? copy === null || copy === void 0 ? void 0 : copy.subBrokerHeading : copy === null || copy === void 0 ? void 0 : copy.memberHeading;
  var body = formatPortalCopy(kind === AccessSuccessKindEnum.SubBroker ? copy === null || copy === void 0 ? void 0 : copy.subBrokerBody : copy === null || copy === void 0 ? void 0 : copy.memberBody, {
    entityName: (entity === null || entity === void 0 ? void 0 : entity.name) || ''
  });
  /**
   * methods
   */

  var closeAction = function closeAction() {
    onClose();
  };

  return /*#__PURE__*/_jsx(Dialog, {
    open: open,
    onClose: closeAction,
    maxWidth: "xs",
    fullWidth: true,
    PaperProps: {
      className: 'rounded-3xl px-2 py-4'
    },
    children: /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-col items-center space-y-4 px-6 py-6 text-center",
      children: [/*#__PURE__*/_jsx(Box, {
        className: "flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50",
        children: /*#__PURE__*/_jsx(Box, {
          className: "flex h-11 w-11 items-center justify-center rounded-full bg-emerald-500",
          children: /*#__PURE__*/_jsx(Box, {
            component: "svg",
            viewBox: "0 0 24 24",
            className: "h-6 w-6 fill-white",
            children: /*#__PURE__*/_jsx("path", {
              d: "M9.6 15.6 4.8 10.8l1.4-1.4 3.4 3.4 8-8 1.4 1.4z"
            })
          })
        })
      }), /*#__PURE__*/_jsx(Typography, {
        component: "h3",
        className: "text-2xl font-black text-[var(--brand-primary)]",
        children: heading
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-sm leading-6 text-gray-500",
        children: body
      }), /*#__PURE__*/_jsxs(Box, {
        className: "flex flex-row items-center space-x-2 rounded-full bg-amber-50 px-4 py-1.5",
        children: [/*#__PURE__*/_jsx(Box, {
          className: "h-2 w-2 rounded-full bg-amber-400"
        }), /*#__PURE__*/_jsx(Typography, {
          className: "text-xs font-bold text-amber-700",
          children: copy === null || copy === void 0 ? void 0 : copy.badge
        })]
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-xs text-gray-400",
        children: copy === null || copy === void 0 ? void 0 : copy.reviewHint
      }), /*#__PURE__*/_jsx(BrandButtonView, {
        size: "large",
        className: "w-full",
        onClick: closeAction,
        children: copy === null || copy === void 0 ? void 0 : copy.backText
      })]
    })
  });
};

export default AccessSuccessDialog;